import React from 'react';
import {IconButton} from 'material-ui';
import {MoreVert} from 'material-ui-icons';

function getRoundCountText({type, totalRounds, round}) {
	if (['warmup', 'cooldown'].includes(type)) {
		return '';
	}
	return `R ${round} / ${totalRounds}`;
}

export default function TopLifeProgressBar({
	currentExcercise,
	excercisesInCurrentRoundCount,
	excercisesInCurrentRoundCompleted,
	time,
	isMenuOpen,
	handleOpenMenu,
	totalRounds,
}) {
	if (!currentExcercise) {
		return null;
	}

	const {
		round,
		position,
		excercise_info: {type},
	} = currentExcercise;
	const isWorkoutPause = position === 99;
	const title = type || (isWorkoutPause ? 'workout' : '');
	const roundCountText = getRoundCountText({type, round, totalRounds});

	return (
		<div className='progressBarWrapper'>
			<div className='progressBarWrapper-roundInfo'>
				<span className='progressBarCurrentRound'>{title}</span>
				{Array.from({length: excercisesInCurrentRoundCount}).map(
					(_, i) => (
						<div
							key={i}
							className={`progressBarBar ${
								i <= excercisesInCurrentRoundCompleted
									? 'filled'
									: 'empty'
							}`}
						></div>
					)
				)}
			</div>
			<div className='progressBarWrapper-excerciseInfo'>
				<span className='progressBar-roundCount'>{roundCountText}</span>

				<span className='progressBar-time'>{time}</span>
				<IconButton
					style={{height: 24, width: 24, zIndex: 200}}
					aria-owns={isMenuOpen ? 'menu-appbar' : null}
					aria-haspopup='true'
					onClick={handleOpenMenu}
					color='inherit'
				>
					<MoreVert />
				</IconButton>
			</div>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/workout/TopLifeProgressBar.js